// @core/api/endpoints/license/get_usage_history.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetUsageHistoryResponse,
} from '../../../types/license';

const BASE_PATH = '/license';

/**
 * Get usage history
 * Returns historical usage snapshots for a license, showing how resource consumption has changed over time.
 */
export async function GetUsageHistory(
  license_id: string,
  options?: RequestOptions
): Promise<GetUsageHistoryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/licenses/:license_id/usage`;
  requestPath = requestPath.replace(':license_id', encodeURIComponent(license_id));
  const requestOptions = options;
  return client.get<GetUsageHistoryResponse>(requestPath, { ...requestOptions });
}
